import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';
import { ImagePageComponent } from '../pages/cms/image/image-page.component';

@Injectable({
  providedIn: 'root',
})
export class ImagesFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<ImagePageComponent>
{
  canDeactivate(
    component: ImagePageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(component.hasChanges, nextState.url);
  }
}
